import classNames from 'classnames';
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

import styles from './index.module.scss';

type Props = {
  readonly className?: string;
  readonly value?: string;
  readonly inputRef?: React.RefObject<HTMLInputElement | undefined>;
  readonly isVisible?: boolean;
  readonly isInteractive?: boolean;
  readonly onChange?: (value: string) => void;
};

const CountryCodeSelector = (
  { className, isVisible = true }: Props,
  ref: ForwardedRef<HTMLDivElement>
) => {
  return (
    <div
      ref={ref}
      className={classNames(styles.countryCodeSelector, isVisible && styles.visible, className)}
    >
      <span>+91</span>
    </div>
  );
};

export default forwardRef(CountryCodeSelector);
